/* eslint-disable react-hooks/exhaustive-deps */
import {
    Box, Button, Checkbox,
    Dialog, FormControl, FormControlLabel,
    IconButton,
    InputAdornment, InputLabel, MenuItem, Select,
    Slide,
    TablePagination,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {forwardRef, useContext, useEffect, useState} from "react";
import {RequestContext} from "../../context/request.context";
import {DataGrid} from "@mui/x-data-grid";
import {MdClose, MdComment, MdArrowBackIos} from "react-icons/md";
import {IoCalendar, IoPerson} from "react-icons/io5";
import dayjs from 'dayjs';
import ViewClient from "../../components/trade/view.client";
import statuses from "../../const/links";
import UpdateOrder from "../../components/trade/update.order";
import {HiReceiptPercent, HiShoppingBag} from "react-icons/hi2";
import {FaMoneyBillAlt} from "react-icons/fa";
import {CgMoreO, CgTimelapse} from "react-icons/cg";
import numberFormat from "../../components/globalFunction/prettierNumber";
import moment from "moment";
import {BiLinkExternal, BiSearch} from "react-icons/bi";
import {IoIosEye} from "react-icons/io";
import FullInfoView from "../../components/trade/fullInfo";
import ViewManager from "../../components/trade/viewManager";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {MobileDatePicker} from "@mui/x-date-pickers";
import {stringToDateTime} from "../../components/globalFunction/prettierDate";
import gridLocale from "../../components/ui/gridLocale";
import {RiFileExcel2Line} from "react-icons/ri";
import {exportOrdersToExcel} from "../../components/trade/export.orders";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const CustomTooltip = ({title}) => {
    const [openTooltip, setOpenTooltip] = useState(false);
    const handleOpen = () => {
        setOpenTooltip(!openTooltip);
    };
    const handleClose = () => {
        setOpenTooltip(false);
    };
    return (
        <Box
            onClick={handleOpen}
            onMouseLeave={handleClose}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
            }}
        >
            <Tooltip title={title} open={openTooltip}>
                <Typography
                    sx={{
                        width: "240px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        fontSize: "0.75rem",
                        lineHeight: 1.66,
                        letterSpacing: "0.03333em",
                    }}
                >
                    {title}
                </Typography>
            </Tooltip>
        </Box>
    );
};

const Trades = ({data = []}) => {
    const {request} = useContext(RequestContext);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(25);
    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [onlyExpired, setOnlyExpired] = useState(false);
    const [exporting, setExporting] = useState(false);
    const [startDate, setStartDate] = useState(dayjs(
        moment().subtract(1, "month").format("YYYY-MM-DD")
    ));
    const [endDate, setEndDate] = useState(dayjs(
        moment().format("YYYY-MM-DD")
    ));
    const listUrl = (p, sz) =>
        `/order/all?page=${p}&size=${sz}&onlyExpired=${onlyExpired}&desc=true&search=${encodeURIComponent(search)}&status=${status}&from=${startDate.format("YYYY-MM-DD")}&to=${endDate.format("YYYY-MM-DD")}`;

    // Tanlangan filtr bo'yicha BARCHA buyurtmalarni (sahifalamasdan) olib,
    // Excel faylga chiqaradi. Bo'sh bo'lsa hech narsa yuklanmaydi.
    const exportExcel = async () => {
        setExporting(true);
        try {
            let orders = data;
            if (!orders.length) {
                const res = await request(listUrl(0, Math.max(total, 1)), "GET");
                orders = res && res.data ? res.data : [];
            }
            if (!orders.length) return;
            exportOrdersToExcel(orders, {
                from: startDate.format("YYYY-MM-DD"),
                to: endDate.format("YYYY-MM-DD"),
            });
        } finally {
            setExporting(false);
        }
    };

    useEffect(() => {
        if (data.length > 0) {
            setRows(data);
            setTotal(data.length);
            return;
        }
        setLoading(true);
        request(listUrl(page, size), "GET").then((res) => {
            setLoading(false);
            setRows(res.data);
            setTotal(res.totalElements);
        });
    }, [page, size, search, status, startDate, endDate, onlyExpired]);
    const columns = [
        {
            field: "createdAt",
            headerName: (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <IoCalendar fontSize={18}/>
                    <Typography>Sana</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                return (
                    <Typography variant="caption">
                        {moment(params.row.createdAt).format("DD.MM.YYYY HH:mm ")}
                    </Typography>
                );
            },
        },
        {
            field: "client",
            headerName: (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                    }}
                >
                    <IoPerson
                        style={{
                            fontSize: 18,
                        }}
                    />
                    <Typography>Mijoz</Typography>
                </Box>
            ),
            width: 250,
            renderCell: (params) => {
                let client = params.row.client || params.row.cbClient;
                return client ? (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <Typography variant="caption" title={client.name}>
                            {client.name}
                        </Typography>
                        <Tooltip title="Mijoz haqida">
                            <IconButton
                                size="small"
                                color="info"
                                onClick={() => {
                                    setDialog({
                                        open: true,
                                        data: params.row,
                                        type: params.row.client ? "client" : "cbClient",
                                    });
                                }}
                            >
                                <BiLinkExternal/>
                            </IconButton>
                        </Tooltip>
                    </Box>
                ) : (
                    <>- - -</>
                );
            },
        },
        {
            field: "products",
            headerName: (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <HiShoppingBag fontSize={18}/>
                    <Typography sx={{ml: 1}}>Summa</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                let products = params.row.products;
                let totalSum = products
                    ? products.reduce((sum, item) => {
                        return sum + item.price * item.amount;
                    }, 0)
                    : "";
                return (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                            cursor: "pointer",
                        }}
                    >
                        <Typography variant="caption">{numberFormat(totalSum)}</Typography>
                    </Box>
                );
            },
        },
        {
            field: "amountPayment",
            headerName: (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <FaMoneyBillAlt fontSize={18}/>
                    <Typography sx={{ml: 1}}>To'lov</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                        }}
                    >
                        <Typography variant="caption">
                            {params.value * 1 !== 0 ? numberFormat(params.value) : "- - - "}
                        </Typography>
                    </Box>
                );
            },
        },
        {
            field: "discount",
            headerName: (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <HiReceiptPercent fontSize={18}/>
                    <Typography sx={{ml: 1}}>Skidka</Typography>
                </Box>
            ),
            width: 150,
            renderCell: (params) => {
                let discount = params.row.discount;
                return (
                    <Typography variant="caption" title={params.value}>
                        {discount ? (
                            <Typography variant="caption" color="error" title="skidka">
                                {numberFormat(discount)}
                            </Typography>
                        ) : (
                            <>- - -</>
                        )}
                    </Typography>
                );
            },
        },
        {
            field: "status",
            align: "center",
            headerName: (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <CgTimelapse fontSize={18}/>
                    <Typography sx={{ml: 1}}>Status</Typography>
                </Box>
            ),
            width: 180,
            renderCell: (params) => {
                const status = statuses.find((item) => item.value === params.value);
                return (
                    status && (
                        <Box>
                            <Typography
                                variant="caption"
                                color={"white"}
                                bgcolor={status.bg}
                                sx={{
                                    borderRadius: "7px",
                                    padding: "5px 15px",
                                    cursor: "pointer",
                                    boxShadow: "0px 3px 5px 0px rgba(0,0,0,0.2)",
                                }}
                                onClick={() => {
                                    setOpenUpdate({
                                        open: true,
                                        data: params.row,
                                    });
                                }}
                            >
                                {status.name}
                            </Typography>
                        </Box>
                    )
                );
            },
        },
        {
            field: "description",
            headerName: (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <MdComment fontSize={18}/>
                    <Typography sx={{ml: 1}}>Izoh</Typography>
                </Box>
            ),
            width: 250,
            renderCell: (params) => {
                return <CustomTooltip title={params.value}/>;
            },
        },
        {
            field: "more",
            headerName: (
                <Box sx={{display: "flex", alignItems: "center"}}>
                    <CgMoreO fontSize={18}/>
                    <Typography sx={{ml: 1}}>Batafsil</Typography>
                </Box>
            ),
            width: 150,
            align: "center",
            renderCell: (params) => {
                return (
                    <Tooltip title="Batafsil">
                        <IconButton
                            size="small"
                            sx={{
                                backgroundColor: "#00bfa530",
                            }}
                            color="info"
                            onClick={() => {
                                setDialog({
                                    open: true,
                                    data: params.row,
                                    type: "fullview",
                                });
                            }}
                        >
                            <IoIosEye fontSize={20}/>
                        </IconButton>
                    </Tooltip>
                );
            },
        },
    ];
    const [openUpdate, setOpenUpdate] = useState({
        open: false,
        data: {},
    });
    const [dialog, setDialog] = useState({
        open: false,
        data: {},
        type: "",
    });
    const component = (dialog) => {
        switch (dialog.type) {
            case "client":
                return <ViewClient data={dialog.data.client} width="50%"/>;
            case "cbClient":
                return (
                    <ViewManager
                        data={dialog.data}
                        obj={dialog.data.cbClient}
                        width="50%"
                    />
                );
            case "fullview":
                return <FullInfoView fullData={dialog.data} show={true}/>;
            default:
                return <></>;
        }
    };
    return (
        <Box
            sx={{
                height: "72vh",
                width: "100%",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mt: 2,
                }}
            >
                <Box>
                    <Typography variant="h2">Buyurtmalar</Typography>
                    <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
                        {total
                            ? `Tanlangan sanalar oralig'ida ${total} ta buyurtma.`
                            : "Tanlangan sanalar oralig'ida buyurtma yo'q."}
                    </Typography>
                </Box>
                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "flex-start",
                    gap: "8px",
                }}>
                    <TextField
                        label="Qidirish"
                        variant="outlined"
                        size="small"
                        sx={{mb: 2}}
                        onChange={(e) => {
                            setSearch(e.target.value);
                        }}
                        InputProps={{
                            style: {
                                borderRadius: "16px",
                            },
                            startAdornment: (
                                <InputAdornment position="start">
                                    <BiSearch/>
                                </InputAdornment>
                            ),
                        }}
                    />
                    {/*Dropdown status*/}
                    <FormControl sx={{ml: 2, minWidth: 120}} size={'small'}>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <Select
                            value={status || "-"}
                            label="Status"
                            labelId={"demo-simple-select-label"}
                            onChange={(e) => {
                                if (e.target.value === "-") {
                                    setStatus("");
                                    return;
                                }
                                setStatus(e.target.value);
                            }}>
                            {
                                [
                                    {name: "Barchasi", value: "-"},
                                    ...statuses
                                ].map((item, index) => {
                                    return (
                                        <MenuItem value={item.value} key={index}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })
                            }
                        </Select>
                    </FormControl>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <MobileDatePicker
                            label={"Boshlang'ich sana"}
                            defaultValue={startDate}
                            value={startDate}
                            onAccept={(newValue) => {
                                setStartDate(newValue);
                            }}
                            sx={{
                                marginX: 1
                            }}
                            slotProps={{
                                input: {
                                    readOnly: true,
                                },
                                textField: {
                                    size: 'small'
                                }
                            }}
                        />
                        <MobileDatePicker
                            label={"Oxirgi sana"}
                            defaultValue={endDate}
                            value={endDate}
                            onAccept={(newValue) => {
                                setEndDate(newValue);
                            }}
                            slotProps={{
                                input: {
                                    readOnly: true,
                                },
                                textField: {
                                    size: 'small'
                                }
                            }}
                        />
                    </LocalizationProvider>
                    <FormControlLabel
                        sx={{ml: 1, whiteSpace: "nowrap"}}
                        control={
                            <Checkbox
                                checked={onlyExpired}
                                onChange={() => setOnlyExpired(!onlyExpired)}
                                color="error"
                                size="small"
                            />
                        }
                        label={
                            <Typography variant="body2">Muddati o'tganlar</Typography>
                        }
                    />
                    <Tooltip title="Ro'yxatni Excel faylga yuklab olish (filtr bo'yicha)">
                        <span>
                            <Button
                                variant="outlined"
                                color="success"
                                size="small"
                                startIcon={<RiFileExcel2Line/>}
                                disabled={exporting || (!total && !data.length)}
                                onClick={exportExcel}
                                sx={{whiteSpace: "nowrap", height: 40}}
                            >
                                {exporting ? "Tayyorlanmoqda..." : "Excel"}
                            </Button>
                        </span>
                    </Tooltip>
                </div>

            </Box>
            <DataGrid
                localeText={gridLocale}
                rows={rows}
                columns={columns}
                pagination
                paginationMode="server"
                pageSizeOptions={[25, 50, 100, 200, 500, 1000]}
                rowCount={total}
                loading={loading}
                hideFooter
                getRowClassName={(params) => {
                    if (!params.row.probablyDeliveryDate) return "non-expired";
                    if (Date.now().valueOf() > stringToDateTime(params.row.probablyDeliveryDate).valueOf())
                        return "expired";
                    return "non-expired";
                }}
                sx={{
                    /*
                     * Ilgari bu yerda `backgroundColor: "white"` turardi va
                     * qatorlar oq fonga mo'ljallangan soya bilan chizilardi.
                     * To'q mavzuda jadval o'rnida katta kulrang maydon
                     * qolib ketardi. Endi yuza va chegara mavzudan olinadi.
                     */
                    "& .MuiDataGrid-row": {
                        "&:hover": { backgroundColor: "action.hover" },
                    },
                    /* Muddati o'tgan buyurtma -- ikkala mavzuda ham ko'rinadi */
                    "& .MuiDataGrid-row.expired": {
                        backgroundColor: (t) =>
                            t.palette.mode === "dark"
                                ? "rgba(239, 68, 68, 0.16)"
                                : "rgba(239, 68, 68, 0.10)",
                        "&:hover": {
                            backgroundColor: (t) =>
                                t.palette.mode === "dark"
                                    ? "rgba(239, 68, 68, 0.24)"
                                    : "rgba(239, 68, 68, 0.16)",
                        },
                    },
                    "& .MuiDataGrid-cell": {
                        border: "none",
                        "&:focus": {
                            outline: "none",
                            border: "none",
                        },
                        "&:focus-within": {
                            outline: "none",
                            border: "none",
                        },
                    },
                }}
            />
            <TablePagination
                rowsPerPageOptions={[25, 50, 100, 200, 500, 1000]}
                component="div"
                count={total}
                rowsPerPage={size}
                page={page}
                onPageChange={(e, page) => {
                    setPage(page);
                }}
                onRowsPerPageChange={(e) => {
                    setSize(parseInt(e.target.value, 10));
                    setPage(0);
                }}
                labelRowsPerPage="Qatorlar soni:"
                labelDisplayedRows={({from, to, count}) =>
                    `${from}-${to} dan ${count !== -1 ? count : `more than ${to}`}`
                }
            />
            <Dialog
                fullScreen
                open={dialog.open}
                onClose={() => {
                    setDialog({
                        data: {},
                        open: false,
                    });
                }}
                TransitionComponent={Transition}
            >
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 1,
                    }}
                >
                    <IconButton
                        onClick={() => setDialog({open: false, data: {}})}
                        size="small"
                    >
                        <MdArrowBackIos/>
                    </IconButton>
                    <Typography variant="h6">To'liq ma'lumot</Typography>
                    <IconButton
                        onClick={() => setDialog({open: false, data: {}})}
                        size="small"
                    >
                        <MdClose/>
                    </IconButton>
                </Box>
                {component(dialog)}
            </Dialog>
            <Dialog
                open={openUpdate.open}
                onClose={() => setOpenUpdate({open: false, data: {}})}
            >
                <UpdateOrder
                    data={openUpdate.data}
                    close={() => setOpenUpdate({open: false, data: {}})}
                    updateRows={(row) => {
                        setRows(rows.map((item) => (item.id === row.id ? row : item)));
                    }}
                />
            </Dialog>
        </Box>
    );
};

export default Trades;
